import styled from 'styled-components';
import {
  WHEEL_FONT_SIZES,
  WHEEL_ITEM_ANGLE,
  WHEEL_ITEM_HEIGHT,
  WHEEL_VISIBLE_COUNT,
  WHEEL_PERSPECTIVE
} from './constants';

const getFontSize = (offset: number): number => {
  const abs = Math.abs(offset);
  if (abs < 0.5) return WHEEL_FONT_SIZES[0];
  if (abs < 1.5) return WHEEL_FONT_SIZES[1];
  if (abs < 2.5) return WHEEL_FONT_SIZES[2];
  return WHEEL_FONT_SIZES[3];
};

const VIEWPORT_HEIGHT = WHEEL_ITEM_HEIGHT * WHEEL_VISIBLE_COUNT;

export const WheelViewport = styled.div`
  position: relative;
  height: ${VIEWPORT_HEIGHT}px;
  overflow: hidden;
  perspective: ${WHEEL_PERSPECTIVE}px;
  user-select: none;
  touch-action: none;
`;

export const WheelList = styled.div`
  position: absolute;
  inset: 0;
  pointer-events: none;
`;

export const WheelHighlight = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  top: calc(50% - ${WHEEL_ITEM_HEIGHT / 2}px);
  height: ${WHEEL_ITEM_HEIGHT}px;
  background: ${({ theme }) => theme.colors.background.secondary};
  pointer-events: none;
  z-index: 0;
  border-radius: 7px;
`;

export const TouchCapture = styled.div`
  position: absolute;
  inset: 0;
  z-index: 10;
  touch-action: none;
  -webkit-user-select: none;
  user-select: none;
`;

export const WheelItem = styled.div<{
  $offset: number;
  $isDisabled: boolean;
  $isSnapping: boolean;
}>`
  position: absolute;
  left: 0;
  right: 0;
  height: ${WHEEL_ITEM_HEIGHT}px;
  top: calc(50% - ${WHEEL_ITEM_HEIGHT / 2}px);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: ${({ $offset }) => getFontSize($offset)}px;
  cursor: ${({ $isDisabled }) => ($isDisabled ? 'not-allowed' : 'pointer')};
  color: ${({ theme, $offset, $isDisabled }) => {
    if ($isDisabled) return theme.colors.text.tertiary;
    return Math.abs($offset) < 0.5
      ? theme.colors.systemColors.blue
      : theme.colors.text.primary;
  }};
  transform-origin: center center;
  transform: ${({ $offset }) =>
    `translateY(${$offset * WHEEL_ITEM_HEIGHT}px) rotateX(${$offset * -WHEEL_ITEM_ANGLE}deg)`};
  opacity: ${({ $offset }) => (Math.abs($offset) < 0.5 ? 1 : 0.35)};
  transition: ${({ $isSnapping }) =>
    $isSnapping
      ? 'transform 0.22s cubic-bezier(0.25, 0.46, 0.45, 0.94), opacity 0.22s, font-size 0.12s'
      : 'color 0.1s, font-size 0.08s'};
  will-change: transform, opacity;
`;
